import clsx from "clsx";
import { StepArrow } from "../../../../../icons/StepArrow";

export interface StepDataGenericAccordion {
  title: string;
  badge?: string;
  content: React.ReactNode;
}

interface StepItemPropsGenericAccordion extends StepDataGenericAccordion {
  isOpen: boolean;
  onToggle: () => void;
}

export const StepItemGenericAccordion: React.FC<
  StepItemPropsGenericAccordion
> = ({ title, badge, content, isOpen, onToggle }) => {
  return (
    <div className={clsx("step-item-generic-accordion", isOpen && "isOpen")}>
      <button
        type="button"
        className="step-header"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <div className="step-title" title={title}>{title}</div>
        {badge && <div className="step-badge">{badge}</div>}
        <div className="step-arrow">
          <StepArrow
            width={24}
            height={25}
            className="arrow-icon"
            decorative={true}
          />
        </div>
      </button>

      <div className="step-details">
        <div className="step-details-content">
          {isOpen && <div className="step-content">{content}</div>}
        </div>
      </div>
    </div>
  );
};
